module.exports = __webpack_public_path__ + "img/2.39625554.png";